import { JpClassSkills } from "../models/JpClassSkills";
import { JpClassSkillsDTO } from "../dto/JpClassSkillsDTO";
import { ClassSkill } from "../models/Classes/ClassSkill";
import { useUtility } from "@/composables/useUtility";

export const jpClassSkillsDTOMapper = (dto: JpClassSkillsDTO): ClassSkill => {
  const { mapPseudoBool } = useUtility();

  return new ClassSkill({
    id: dto.skillId,
    typeId: dto.typeId,
    name: dto.skillName,
    assessment: dto.assessment,
    displayOrder: dto.displayOrder,
    active: mapPseudoBool(dto.active) || false,
  });
};
